// AR Folio — real content based on Amrit Raj Singh's CV & portfolio

export const summary = `Product Design Manager with 11+ years of experience creating intuitive digital experiences across web and mobile platforms. Passionate about transforming complex challenges into user-centered solutions that drive business growth and customer satisfaction. Led and mentored high-performing design teams of up to 10 designers, working closely with executive leadership including CEOs and Technical Directors to shape product strategy and vision. Skilled in product design, UX research, usability testing, design systems, and cross-functional collaboration.`;

export const summary2 = `From discovery and problem definition to rapid prototyping and final Figma delivery, I bring a hands-on approach to every stage of the product lifecycle. By combining design thinking, user insights, and Agile methodologies, I have consistently delivered experiences that improved usability scores by 25–35% while aligning user needs with business goals. I thrive at the intersection of strategy, design, and innovation, helping teams build products that are not only functional and beautiful but also meaningful and impactful.`;

export const expertise = [
  { id: 'e1', tag: '01', label: 'Product Design', desc: 'End-to-end product design across web and mobile — from problem definition to Figma handoff.' },
  { id: 'e2', tag: '02', label: 'DesignOps', desc: 'Scalable production design systems with token structure and engineering handoff workflows.' },
  { id: 'e3', tag: '03', label: 'UX Research', desc: 'Interviews, contextual research, usability testing and design thinking — grounded in evidence.' },
  { id: 'e4', tag: '04', label: 'AI-enabled UX', desc: 'Designing with and for AI tools — FigGPT, Galileo, UX Pilot, Claude, Gemini, v0.' },
  { id: 'e5', tag: '05', label: 'Design Leadership', desc: 'Managing teams up to 10 designers, design critiques, quality standards, stakeholder alignment.' },
  { id: 'e6', tag: '06', label: 'Agile & Scrum', desc: 'CSM-certified — sprint planning, backlog grooming, leading scrum meetings.' },
];

export const metrics = [
  { id: 'm1', value: '11+', label: 'Years shipping' },
  { id: 'm2', value: '600+', label: 'Icons designed' },
  { id: 'm3', value: '80+', label: 'Websites delivered' },
  { id: 'm4', value: '35%', label: 'Usability score lift' },
];

export const featuredWork = [
  {
    id: 'fw1',
    title: 'SPM — Strategic Portfolio Management',
    role: 'Product design • Design system',
    year: 'Uppwise',
    industry: 'Enterprise SPM',
    color: 'rgb(199 255 85)',
    image: '/project/spm.png',
  },
  {
    id: 'fw2',
    title: 'VitaSync — Mind, Body & Balance',
    role: 'UX research • Mobile design',
    year: 'R&D',
    industry: 'Health & Wellness',
    color: 'rgb(199 255 85)',
    image: '/project/vita.png',
  },
  {
    id: 'fw3',
    title: 'Doc Connect — a health-secure app',
    role: 'Product strategy • UI',
    year: 'R&D',
    industry: 'Healthcare',
    color: 'rgb(199 255 85)',
    image: '/project/doc-connect.png',
  },
  {
    id: 'fw4',
    title: 'Iconography — 600+ system icons',
    role: 'Design system • Foundations',
    year: 'Project Objects',
    industry: 'System',
    color: 'rgb(199 255 85)',
    image: '/project/icons.png',
  },       
];

export const uxProjects = [
  { id: 'u1', slug: 'spm', title: 'SPM — Strategic Portfolio Management', cat: 'Enterprise SaaS · Design System', year: 'Product Design', desc: 'End-to-end enterprise PPM redesign — with a full token-driven design system spanning 9 core components and multi-persona flows.', img: '/project/spm.png' },
  { id: 'u2', slug: 'iconography', title: 'Iconography', cat: 'System', year: 'Iconography', desc: '600+ icons authored as part of a unified design system used across products.', img: '/project/icons.png' },
  { id: 'u3', slug: 'vitasync', title: 'VitaSync', cat: 'Wellness', year: 'R&D', desc: 'An app offering Mind, Body & Balance \u2014 daily wellness rituals, simplified.', img: '/project/vita.png' },
  { id: 'u4', slug: 'dmart-comfort', title: 'DMart Comfort', cat: 'Retail', year: 'R&D', desc: 'Save time and energy by avoiding long checkout queues.', img: '/project/d-mart.png' },
  { id: 'u5', slug: 'cocobite', title: 'CocoBite', cat: 'Food', year: 'R&D', desc: 'A food delivery application with quick reorder and smart shortlists.', img: '/project/coco.png' },
  { id: 'u6', slug: 'kitchenrush', title: 'KitchenRush', cat: 'Food', year: 'R&D', desc: 'Fast and reliable food delivery with cloud-kitchen first design.', img: '/project/kitchenrush.png' },
  { id: 'u7', slug: 'smartbus', title: 'SmartBus', cat: 'Transit', year: 'R&D', desc: 'Live tracking and ticket booking for public bus transit.', img: '/project/smartbus.png' },
  { id: 'u8', slug: 'rydigo', title: 'Rydigo', cat: 'Mobility', year: 'R&D', desc: 'A digital driver solution \u2014 documents, earnings and routes in one place.', img: '/project/rydigo.png' },
  { id: 'u9', slug: 'cvs', title: 'CVS — Contactless Verification System', cat: 'System', year: 'R&D', desc: 'A contactless kiosk that cut warehouse check-in from 4 minutes to 48 seconds.', img: '/project/cvs.png' },
  { id: 'u10', slug: 'staylo', title: 'Staylo', cat: 'Travel', year: 'R&D', desc: 'A premium stay facility platform with curated properties.', img: '/project/staylo.png' },
  { id: 'u11', slug: 'TTM', title: 'TTM', cat: 'Enterprise', year: 'Product Design', desc: 'A smart decision in managing a distributed workforce.', img: '/project/ttm.png' },
  { id: 'u12', slug: 'doc-connect', title: 'Doc Connect', cat: 'Healthcare', year: 'R&D', desc: 'Health-secure app connecting patients with verified doctors.', img: '/project/doc-connect.png' },
   {id: 'u13', slug: 'PPM', title: 'PPM', cat: 'Enterprise', year: 'Product Design', desc: 'Seeing the whole picture while managing every detail', img: '/project/ppm.png' },
   {id: 'u14', slug: 'CWM', title: 'CWM', cat: 'Enterprise', year: 'Product Design', desc: 'The digital workspace where work actually happens', img: '/project/cwm.png' },
];

export const UX_CATEGORIES = ['All', 'Enterprise', 'Healthcare', 'Food', 'Travel', 'Wellness', 'Transit', 'Mobility', 'Retail', 'System'];

export const websiteProjects = [
  { id: 'w1', slug: 'the-book-store', title: 'The Book Store', cat: 'E-Learning', desc: 'The smart choice for the future — an e-learning website UI.', img: '/website/bookstore-cover.png' },
  { id: 'w2', slug: 'azad', title: 'AZAD', cat: 'Manufacturing', desc: 'Comprehensive platform for bus body modifiers.', img: '/website/azad-cover.png' },
  { id: 'w3', slug: 'logoipsum', title: 'LogoIpsum', cat: 'Template', desc: 'A software development solutions website template.', img: 'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?w=1200&q=80' },
  { id: 'w4', slug: 'gadsec-solution', title: 'Gadsec Solution', cat: 'Security', desc: 'CCTV cameras and security appliances manufacturer platform.', img: '/website/gadsec-cover.png' },
  { id: 'w5', slug: 'hughes-chem', title: 'Hughes Chem Ltd', cat: 'Industrial', desc: 'Comprehensive platform for bird management products.', img: '/website/huge-cover.png' },
  { id: 'w6', slug: 'knox-artistie', title: 'Knox Artistie', cat: 'Music', desc: 'Showcasing the latest album release “Bottle Khol”.', img: '/website/knox-cover.png' },
  { id: 'w7', slug: 'wellness-india', title: 'Wellness India', cat: 'Healthcare', desc: 'Platform for wellness and health services across India.', img: '/website/wellness-cover.png' },
  { id: 'w8', slug: 'dubai-tickets', title: 'Dubai Tickets', cat: 'Travel', desc: 'Tour and travel company website for Dubai experiences.', img: '/website/dubai-cover.png' },
];

export const philosophy = [
  { id: 'ph1', word: 'Empathy', sub: 'before solutions' },
  { id: 'ph2', word: 'Clarity', sub: 'over cleverness' },
  { id: 'ph3', word: 'Systems', sub: 'over screens' },
  { id: 'ph4', word: 'Evidence', sub: 'over opinions' },
];

export const experience = [
  {
    id: 'x1',
    company: 'Uppwise Tech India Pvt Ltd',
    role: 'Product Design Manager',
    period: 'Nov 2022 — Present',
    bullets: [
      'Led and managed a team of up to 10 designers (direct reports) across parallel product tracks, reporting to the Technical Director and CEO.',
      'Conducted structured design critiques, set quality standards, and improved usability scores by 25–30%.',
      'Implemented DesignOps practices and built a scalable production design system with token structure and engineering handoff workflows.',
      'Presented design strategy directly to the CEO and Technical Director, articulating decisions in business terms.',
      'Leveraged AI tools to optimise design workflow and accelerate exploration.',
    ],
    website: 'https://www.uppwise.com/'
  },
  {
    id: 'x2',
    company: 'Project Objects Infocom India Pvt Ltd',
    role: 'Technology Lead — UI/UX',
    period: 'Jun 2018 — Nov 2022',
    bullets: [
      'Owned UI/UX assets and application redesigns for clients including Nestlé, Blue Triton, and Robert Walters.',
      'Aligned work to usability standards, accessibility guidelines, and product specifications.',
      'Established user stories and sprint planning documentation for management submission.',
      'Independently authored 600+ icons that became part of the product design language.',
    ],
    website: 'https://www.projectobjects.com'
  },
  {
    id: 'x3',
    company: 'PO Technologies',
    role: 'Senior UI/UX Designer',
    period: 'Jan 2018 — May 2018',
    bullets: [
      'Created high-fidelity wireframes and interactive prototypes across web and mobile.',
      'Cut design-related revisions by 35% during development and validation.',
      'Conducted user research to inform the design process and streamlined the workflow.',
    ],
    website: '#'
  },
  {
    id: 'x4',
    company: 'Spark Infosystems',
    role: 'Web Designer',
    period: 'Jan 2016 — Jan 2018',
    bullets: [
      'Developed wireframes and prototypes for 80+ websites, landing pages, and digital emailers.',
      'Collaborated with clients, product managers and developers to translate requirements into effective design.',
      'Owned brand-management visuals for multiple client accounts.',
    ],
    website: 'https://www.linkedin.com/company/spark-infosystems'
  },
  {
    id: 'x5',
    company: 'Adept Technologies',
    role: 'UI Designer',
    period: 'Jan 2015 — Dec 2015',
    bullets: [
      'Developed responsive websites and web/mobile application screens focused on usability and accessibility.',
      'Designed creative graphical assets for promotional and marketing purposes.',
      'Executed client presentations with finalized design proposals.',
    ],
    website: 'https://www.adepttech.com/'
  },
];

export const education = [
  { id: 'ed1', course: 'PG in Design', school: 'IIT Roorkee' },
  { id: 'ed2', course: 'B.Sc. IT', school: 'Kuvempu University' },
  { id: 'ed3', course: 'GNIIT — Technical Diploma', school: 'NIIT University' },
];

export const certifications = [
  { id: 'c1', name: 'Certified ScrumMaster® (CSM)' },
  { id: 'c2', name: 'Google UX Professional' },
  { id: 'c3', name: 'Digital Skills: User Experience — Accenture' },
  { id: 'c4', name: 'UX & Accessible Design — UAL Creative Computing' },
  { id: 'c5', name: 'UX Design Strategy & Application — FutureLearn' },
  { id: 'c6', name: 'Customer Profiling & Design Sprints' },
  { id: 'c7', name: 'Project Management: Beginner to Project Manager' },
  { id: 'c8', name: 'Career Productivity Skills — NSDC' },
  { id: 'c9', name: 'Merit Recognition for National IT Aptitude' },
];

export const aiTools = [
  { id: 'a1', name: 'Figma AI', use: 'First Draft, Make Designs, auto-rename — native generative UI inside Figma.' },
  { id: 'a2', name: 'FigJam AI', use: 'Workshops on autopilot — sticky-note synthesis, themes, and templates in seconds.' },
  { id: 'a3', name: 'Galileo AI', use: 'Prompt to high-fidelity UI — fast concept exploration with editable Figma output.' },
  { id: 'a4', name: 'UX Pilot', use: 'AI research co-pilot — interview synthesis, themes, persona drafts.' },
  { id: 'a5', name: 'Uizard Autodesigner', use: 'Sketch / text / screenshot → multi-screen mockups and flows.' },
  { id: 'a6', name: 'v0 by Vercel', use: 'Production-ready React / Tailwind components from natural language prompts.' },
  { id: 'a7', name: 'Cursor', use: 'AI-pair coding for design engineering — token wiring and component handoff.' },
  { id: 'a8', name: 'Magic Patterns', use: 'Generative UI library — composable React patterns for fast prototyping.' },
  { id: 'a9', name: 'Visily', use: 'Wireframes and prototypes from screenshots, sketches, or plain text.' },
  { id: 'a10', name: 'Khroma', use: 'AI-curated colour palettes trained on the colours you actually like.' },
  { id: 'a11', name: 'Dovetail AI', use: 'Research repository with AI summarisation across interviews and notes.' },
  { id: 'a12', name: 'Maze AI', use: 'AI-driven usability testing — task generation, analysis, and insight summaries.' },
  { id: 'a13', name: 'Adobe Firefly', use: 'On-brand generative imagery, vectors and texture work for design assets.' },
  { id: 'a14', name: 'Midjourney', use: 'High-end concept art, mood boards, and brand exploration imagery.' },
  { id: 'a15', name: 'Runway', use: 'AI motion and video — micro-interaction prototyping and explainer reels.' },
  { id: 'a16', name: 'ChatGPT + Claude', use: 'UX writing, copy iteration, content strategy and stakeholder narratives.' },
];

export const skillGroups = [
  { id: 's1', title: 'Product & Strategy', items: ['DesignOps', 'Product Strategy', 'Product Vision', 'Strategic Thinking', 'UX Optimization', 'Research & Trend Analysis'] },
  { id: 's2', title: 'Design & Research', items: ['Design System', 'UI Design', 'UX', 'Mobile App Design', 'Visual Design', 'Information Architecture', 'Design Thinking', 'Usability Testing', 'Contextual Research'] },
  { id: 's3', title: 'Agile & Scrum', items: ['Agile', 'Scrum Framework', 'Sprint Planning', 'Backlog Grooming', 'Workflow Optimization'] },
  { id: 's4', title: 'Tools', items: ['Figma', 'Adobe XD', 'Framer', 'Illustrator', 'Sketch', 'Canva'] },
  { id: 's5', title: 'Frontend', items: ['HTML & CSS3', 'Tailwind CSS', 'Material UI', 'Bootstrap'] },
  { id: 's6', title: 'Leadership', items: ['Team Management', 'Stakeholder Alignment', 'Design Critiques', 'Customer Relations', 'Design Process Presentation'] },
];

export const skillsCloud = [
  { name: 'Research', size: 1.2, x: 10, y: 18 },
  { name: 'Figma', size: 1.5, x: 60, y: 12 },
  { name: 'Design Systems', size: 1.1, x: 30, y: 38 },
  { name: 'Scrum', size: 1.0, x: 75, y: 42 },
  { name: 'Motion', size: 0.95, x: 20, y: 60 },
  { name: 'AI Tools', size: 1.15, x: 55, y: 70 },
  { name: 'Strategy', size: 1.2, x: 80, y: 75 },
  { name: 'Workshops', size: 0.95, x: 10, y: 80 },
  { name: 'Iconography', size: 1.0, x: 45, y: 88 },
  { name: 'Accessibility', size: 1.0, x: 70, y: 22 },
  { name: 'DesignOps', size: 1.05, x: 38, y: 8 },
  { name: 'Tokens', size: 0.9, x: 88, y: 56 },
];

export const timeline = [
  { id: 't1', year: 'Nov 2022', title: 'Product Design Manager, Uppwise', body: 'Leading a team of 10 designers across parallel product tracks. DesignOps, design systems, AI workflows.' },
  { id: 't2', year: 'Jun 2018', title: 'Tech Lead UI/UX, Project Objects', body: 'Owned UI/UX for Nestlé, Blue Triton, Robert Walters. Authored 600+ system icons.' },
  
  { id: 't3', year: 'Jan 2018', title: 'Sr. UI/UX Designer, PO Technologies', body: 'High-fidelity wireframes and prototypes. Reduced design revisions by 35%.' },
  { id: 't4', year: 'Jan 2016', title: 'Web Designer, Spark Infosystems', body: '80+ websites, landing pages and emailers for clients across industries.' },
  { id: 't5', year: 'Jan 2015', title: 'UI Designer, Adept Technologies', body: 'First role. Responsive websites, brand visuals, and client presentations.' },
];

export const labs = [
  {
    id: 'l1',
    title: 'Figma + FigJam AI in production design',
    tag: 'AI × UX',
    body: 'How I use Figma\u2019s native AI features — First Draft, Make Designs, and FigJam AI — to compress the first 70% of every project: variant generation, copy iteration, and rapid IA exploration without leaving the canvas.',
    image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?w=1600&q=85',
    notebookUrl: 'https://www.figma.com/community',
    readingTime: '8 min',
  },
  {
    id: 'l2',
    title: 'UX Pilot for research synthesis at scale',
    tag: 'Research',
    body: 'Running 30+ user interviews through UX Pilot and Dovetail AI to surface themes, contradictions, and verbatim quotes — in the time it used to take to read a single transcript.',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&q=85',
    notebookUrl: 'https://uxpilot.ai',
    readingTime: '10 min',
  },
  {
    id: 'l3',
    title: 'Galileo + UIzard for rapid concept rounds',
    tag: 'Generative UI',
    body: 'Prompt → hi-fi screen → stakeholder review in under 20 minutes. A practical workflow for going from spoken intent to credible visual concepts using Galileo AI and UIzard.',
    image: 'https://images.unsplash.com/photo-1559028012-481c04fa702d?w=1600&q=85',
    notebookUrl: 'https://www.usegalileo.ai',
    readingTime: '7 min',
  },
  {
    id: 'l4',
    title: 'v0 by Vercel as a design-to-code partner',
    tag: 'Design Engineering',
    body: 'How v0 reshaped my engineering handoff. Components arrive as production-ready React, design tokens intact, and the back-and-forth with engineering drops to almost zero.',
    image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=1600&q=85',
    notebookUrl: 'https://v0.dev',
    readingTime: '9 min',
  },
];

export const testimonials = [
  { id: 'ts1', quote: 'A rare blend of taste, rigour and product instinct. Amrit ships work that quietly raises the bar.', author: 'Engineering peer', role: 'Uppwise' },
  { id: 'ts2', quote: 'Half designer, half strategist, fully obsessed with the user. Our team levelled up just by working with him.', author: 'Product peer', role: 'Project Objects' },
  { id: 'ts3', quote: 'Turned a messy enterprise app into something customers actually want to open in the morning.', author: 'Stakeholder', role: 'Enterprise client' },
];

export const journal = [
  { id: 'j1', slug: 'designing-the-unfamiliar', title: 'On designing the unfamiliar', date: 'Mar 2025', read: '6 min', cat: 'AI UX', cover: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=900&q=80' },
  { id: 'j2', slug: 'design-system-that-scales', title: 'Building a design system that scales', date: 'Feb 2025', read: '5 min', cat: 'DesignOps', cover: 'https://images.unsplash.com/photo-1481487196290-c152efe083f5?w=900&q=80' },
  { id: 'j3', slug: 'accessibility-end-to-end', title: 'Designing for accessibility, end-to-end', date: 'Jan 2025', read: '7 min', cat: 'Craft', cover: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=900&q=80' },
];

export const personalGallery = [
  { id: 'g1', src: '/snap/g1.jpg', caption: 'Happiness', note: 'Holding the smallest, biggest thing.', tilt: -3 },
  { id: 'g2', src: '/snap/g2.jpg', caption: 'Finding Peace', note: 'Prayer flags, Himachal.', tilt: 2 },
  { id: 'g3', src: '/snap/g3.jpg', caption: 'Bullet & Hills', note: 'A weekend ride into the mountains.', tilt: -1.5 },
  { id: 'g4', src: '/snap/g4.jpg', caption: 'Solo Walk', note: 'Long roads, longer thoughts.', tilt: 3 },
  { id: 'g5', src: '/snap/g5.jpg', caption: 'Adventure', note: 'Snow, sunlight, smile.', tilt: -2.5 },
  { id: 'g6', src: '/snap/g6.jpg', caption: 'Work On', note: 'The desk, the moment, the focus.', tilt: 1.5 },
  { id: 'g7', src: '/snap/g8.jpeg', caption: 'Interviews', note: 'Behind the scenes of a UX chat.', tilt: -2 },
  { id: 'g8', src: '/snap/g7.jpg', caption: 'UX Talks', note: 'On stage, sharing what I learn.', tilt: 2.5 },
];

export const trustedBy = [
  { id: 'b1', logo: '/logos/eni.png' },
  { id: 'b2', logo: '/logos/nestle.png' },
  { id: 'b3', logo: '/logos/bluetriton.png' },
  { id: 'b4', logo: '/logos/robertwalters.png' },
  { id: 'b5', logo: '/logos/bancasella.png' },
  { id: 'b6', logo: '/logos/axa.png' },
  { id: 'b7', logo: '/logos/total.png' },
  { id: 'b8', logo: '/logos/dentsu.png' },
  { id: 'b9', logo: '/logos/breda.png' },
  { id: 'b10', logo: '/logos/enel.png' },
  { id: 'b11', logo: '/logos/denso.png' },
  { id: 'b12', logo: '/logos/feroglobe.png' },
  { id: 'b13', logo: '/logos/finc.png' },
  { id: 'b14', logo: '/logos/primo.png' },
  { id: 'b15', logo: '/logos/rsm.png' },
  { id: 'b16', logo: '/logos/tryg.png' },
];

export const languages = [
  { id: 'lg1', name: 'English', level: 'Advanced' },
  { id: 'lg2', name: 'Hindi', level: 'Native' },
  { id: 'lg3', name: 'Bengali', level: 'Intermediate' },
  { id: 'lg4', name: 'German', level: 'Beginner' },
];